<template>
    <div class="full-width" ref="chatRoomViewDom" :style="{width: windowInnerWidth, height: windowInnerHeight}" v-loading="loading">
        <div style="width: 100%; height: 100%; overflow-y: auto; overflow-x: hidden">
            <el-scrollbar>
                <div style="text-align: right; padding: 10px; background: #73767a;">
                    <span style="color: #ffffff; float: left; padding: 10px;" @click="enterGroupTag = false" v-show="enterGroupTag"><font-awesome-icon icon="fa-solid fa-chevron-left" /></span>

                    <langSelect :confirmFlag="false" :size="'default'" />
                </div>
                <el-card>
                    <template #header>
                        <div v-show="!enterGroupTag">
                            <chatInfoCard :obj="groupInfoObj" />
                        </div>
                    </template>

                    <div style="border: 1px #DCDFE6 solid;" v-if="!enterGroupTag">
                        <chatGroupFileList v-if="null != groupInfoObj.roomId" :roomId="groupInfoObj.roomId" />
                    </div>

                    <div v-show="!enterGroupTag" style="margin-top: 20px">
                        <el-button size="large" type="success" tkey="進入" @click="enterGroupTag = true">{{i18n.tkey("lang_enter_text")}}</el-button>
                    </div>

<!--                    <div style="text-align: left;box-sizing: border-box;padding: 8px;font-size: 14px; margin-top: 20px;" v-if="enterGroupTag">-->
<!--                        <div style="border-bottom: 1px #DCDFE6 solid;">-->
<!--                            <span style="margin-left: 10px" tkey="群組成員">{{i18n.tkey("lang_group_member")}}</span>-->
<!--                        </div>-->
<!--                    </div>-->

                    <pageTitle :titleText="i18n.tkey('lang_group_member')" style="margin-top: 20px" v-show="enterGroupTag" />

                    <div v-loading="cardLoading" v-if="enterGroupTag">
                        <holderCard v-for="(v, i) in cardList" :key="v.id" :card="v" :showDelBtn="false" />
                    </div>
                </el-card>

                <cardShare />
            </el-scrollbar>
        </div>

        <chatFloatComponent ref="chatIframeComponent" v-show="showChatView" v-if="null != userInfoRef.token" @clickClose="showChatView = false" />

        <el-dialog
                v-model="loginVisible"
                :width="myUtil.isMobile() ? '90%' : '600px'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <loginComponent @login-check-complete="loginComplete" />
        </el-dialog>

        <loginComponent v-if="loginVisible == true" :v-show="false" @login-check-complete="loginVisible = false" />
    </div>
</template>

<script setup>
    import {ref, onMounted, getCurrentInstance, onBeforeMount, inject, computed, toRef, provide} from "vue";
    import chatInfoCard from "@/components/shopopee/chat/chatInfoCard"
    import chatGroupFileList from "@/components/shopopee/chat/chatGroupFileList"
    import holderCard from "@/components/shopopee/card/holderCard"
    import cardShare from "@/components/shopopee/share/cardShare"
    import loginComponent from "@/components/loginComponent"
    import pageTitle from "@/components/shopopee/common/pageTitle"
    import chatApi from "@/request/chatApi";
    import myUtil from "@/util/util";
    import cardApi from "@/request/api";
    import {usePageinfo} from "@/stores/pageinfo";
    import {useUserinfo} from "@/stores/userinfo";
    import { Close } from '@element-plus/icons-vue'
    import langSelect from "@/components/shopopee/common/langSelect"
    import chatFloatComponent from "@/components/shopopee/chat/chatFloatComponent"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'

    library.add(faChevronLeft)

    const props = defineProps(["rid"])

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")
    const groupInfoObj = ref({})

    const windowInnerWidth = ref((window.innerWidth) + "px")
    const windowInnerHeight = ref((window.innerHeight) + "px")

    // const chatWidth = ref("425px")
    // const chatHeight = ref("425px")

    const loading = ref(false)
    const cardLoading = ref(false)

    const chatDialogWidth = ref("465px")

    //是否显示聊天
    const showChatView = ref(false)
    //是否顯示登錄
    const loginVisible = ref(false)
    //登錄後要執行的方法
    let loginCallbackFunc = null

    const cardList = ref([])

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())

    //進入頁面時是否已登錄
    const loginTag = ref(false)
    //是否進入群組
    const enterGroupTag = ref(false)


    function getChatGroupInfo(){
        loading.value = true
        const request = chatApi.getGroupinfo
        const params = request.getParams()

        params.roomId = props.rid

        request.send(params, (res) => {
            loading.value = false
            if (res.success == true){
                groupInfoObj.value = res.data

                getGroupUserCardList()
            }else{
                groupInfoObj.value = {}
                cardList.value = []
            }
        })

    }

    function getGroupUserCardList(){
        cardLoading.value = true

        const addinfo2List = []

        if (null != groupInfoObj.value.users){
            groupInfoObj.value.users.forEach((v, i) => {
                if (null != v._id){
                    addinfo2List.push(v._id)
                }
            })
        }

        const request = cardApi.queryMemberworkByAddinfo2List
        const params = request.getParams()

        params.stringList = addinfo2List

        request.send(params, (res) => {
            cardLoading.value = false

            if (res.code == 200){
                cardList.value = res.detail
            }else{
                myUtil.alertError(res.msg)
            }

        })

    }

    function clickCardChatBtn(login){
        if (userInfoRef.value.memberStatus != -1){
            loginCallbackFunc = () => {
                clickCardChatBtn(login)
            }
            loginVisible.value = true
        }else{
            if (login == userInfoRef.value.login){
                myUtil.alertWarning(i18n.tkey("lang_unable_to_chat_with_oneself"))
            }else{
                openCardChat(login)
            }
        }
    }

    function openCardChat(login){
        showChatView.value = true
        proxy.$refs.chatIframeComponent.openPersonChat(login)

    }

    function loginComplete(){
        loginVisible.value = false

        if (null != loginCallbackFunc){
            loginCallbackFunc()
        }
    }

    provide('myCardViewFunc', {
        clickCardChatBtn,
    })

    onBeforeMount(() => {
        if (myUtil.isNotEmpty(props.rid)){
            getChatGroupInfo()
        }

        // chatWidth.value = myUtil.isMobile() ? `${Math.floor(window.innerWidth * 0.9 - 35)}px` : '900px'
        // chatHeight.value = myUtil.isMobile() ? `${Math.floor(window.innerHeight * 0.9)}px` : '650px'

        if (null != userInfoRef.value.token){
            loginTag.value = true
        }
    })

    onMounted(() => {
        const width = proxy.$refs.chatRoomViewDom.offsetWidth

        if (null == props.useChat || true === props.useChat){
            if (width > 1024){
                chatDialogWidth.value = `941px`
            }else{
                chatDialogWidth.value = `${width}px`
            }
        }
        showChatView.value = false
        // loginVisible.value = true


    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        height: 100%;
        position: relative;
        overflow-y: auto;
        box-sizing: border-box;
        /*padding: 8px;*/
    }

    .chatIframeBox {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #00000033;
        display: flex;
        align-items: center;
        justify-content: center;
    }



</style>

<style>
    body {
        margin: 0;
    }
</style>